// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_1TuhQpUP9oryzGF8T1Xf_E","title":"_3uni-4uEyRb59FxF6xXnrn","body":"_3e2_61NlrxbS7K6lD9bR2v"};